import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
} from 'react';
import { useSelector } from 'react-redux';

import { toast } from 'react-toastify';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { isNull, isArray, concat, trim, isUndefined } from 'lodash';
import * as Yup from 'yup';
import { isEmpty } from 'lodash';

import api from '~/services/api';
import qs from 'querystring';

import { FRENTISTA, GPP, GPPEM } from '~/constants/perfil';

import { t, parseDateString } from '~/helpers';
import { Report } from '~/components';
import { DateTime, Autocomplete, RadioGroup, Select } from '~/components/Form';

export default function RelDadosTurnosPostoPeriodoTanque() {
  const [open, setOpen] = useState(true);
  const [post, setPost] = useState({});
  const [tank, setTank] = useState({ tafi_codigo: '', tafi_nome: '' });
  const [tanks, setTanks] = useState([]);
  const [tankValue, setTankValue] = useState('');

  const reportRef = useRef(null);

  const [valuePosto, setValuePosto] = React.useState('');
  const [inputValuePosto, setInputValuePosto] = React.useState('');
  const [multiPosto, setMultiPosto] = React.useState(false);
  const [disablePosto, setDisablePosto] = useState(false);
  const [postoRequired, setPostoRequired] = useState(false);

  const { profile } = useSelector((state) => state.user);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === FRENTISTA) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      }
      if (profile.glousuariotipo === GPP) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      }
      if (profile.glousuariotipo === GPPEM) {
        setPostoRequired(true);
        setMultiPosto(true);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleGetTanques = useCallback(async () => {
    try {
      const { data } = await api.get('tanquesfisicos', {
        params: {
          wherefield: ['poco_codigo'],
          valuewherefield: [post.poco_codigo],
          typewherefield: ['EQUALS'],
          pagezie: 99999,
          pesquisalista: true,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });

      setTanks(
        data.items.map((item) => ({
          label: `${item.tafi_codigo} - ${item.tafi_nome}`,
          value: {
            value: item.tafi_codigo,
            tanque: `${item.tafi_codigo} - ${item.tafi_nome}`,
            tanquevirtual: item.tavi_codigo,
          },
        }))
      );
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [post]);

  useEffect(() => {
    setTankValue('');
    setTank('');
    if (!isNull(post.poco_codigo) && !isUndefined(post.poco_codigo)) {
      handleGetTanques();
    } else {
      setTanks([]);
      setTank('');
    }
  }, [post]);

  const handleValidate = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        // datahorainicial: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        // datahorafinal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(datahorafinal, `A data não pode ser superior a ${datahorafinal}`)
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
        tanque: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
        posto: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(data, { abortEarly: false });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }, []);

  const onSerializeData = useCallback(
    (data) => {
      return {
        ...data,
        tanque: '',
        tanquefisico: tank.value,
        tanquefisicostr: tankValue,
        unidade: post.poco_codigo,
        unidadestr: post.poco_descricao,
        tanquevirtual: tank.tanquevirtual ?? '',
      };
    },
    [post, tank]
  );

  return (
    <Report
      ref={reportRef}
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      validate={handleValidate}
      title="Dados dos turnos do posto no periodo - tanque"
      relatorio="dadosturnopostoperiodotanque"
      initials={{
        datahorainicial,
        datahorafinal,
        formato: 'pdf',
        posto: valuePosto,
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="posto"
        label="poco_descricao"
        title="Posto"
        url="postosporusuario"
        unique="poco_codigo"
        getValue={(value) => {
          setPost(value);
          reportRef.current.clearField('tanque');
        }}
        disabled={disablePosto}
      />

      <Select
        name="tanque"
        label="Tanque"
        options={tanks}
        getValue={(value) => {
          value ? setTank(value) : setTank('');
          value ? setTankValue(value.tanque) : setTankValue('');
        }}
        inputValue={tankValue}
      />

      <RadioGroup
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />

      {/* <RadioGroup
        row
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
      /> */}
    </Report>
  );
}
